import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import { StatusErrorSearchIntegration, TableFilterStateDataIntegrationProps } from './TableSearchDataIntegration/interface';
import { TableSearchDashDataIntegration } from './TableSearchDataIntegration';
import TableDataIntegrationItems from './TableDataIntegrationItems';
import { TableDataIntegration } from './TableDataIntegration';

import { modelDataIntegrationItems } from './TableDataIntegrationItems/model';
import { HealthOperatorProps } from 'models/HealthOperator';
import { modelDataIntegration } from './TableDataIntegration/model';
import { IBatchRequestResponse } from 'models/Batch';

import HealthOperatorServices from 'services/healthOperator.service';

import { getMaxDateInSearchFilter, getMinDateInSearchFilter } from 'utils/Date';
import { DateOutputStr } from 'utils/DateOutput';

import { ContainerFilterDataIntegration } from './styles';

const InitialStateIntegration = {
  error: undefined,
  data: undefined,
  totalPages: 0,
  pageSize: 0,
  total: 0,
};

export const ReportDashDataIntegration: React.FC = () => {
  const user = useSelector((state: RootState) => state.user);
  const pageTotal = 10;
  const healthOperatorServices = new HealthOperatorServices();

  const [tableFilter, setTableFilter] = useState<TableFilterStateDataIntegrationProps>({
    search: "",
    startPeriod: new Date(`${DateOutputStr(getMinDateInSearchFilter().toISOString(), 'yyyy-MM-dd')}T00:00:00.000Z`),
    lastPeriod: new Date(`${DateOutputStr(getMaxDateInSearchFilter().toISOString(), 'yyyy-MM-dd')}T23:59:59.999Z`),
    status: StatusErrorSearchIntegration
  });

  const tableDataIntegrationBy = "orderDate desc, id desc";

  const [dataIntegration, setDataIntegration] = useState<IBatchRequestResponse<HealthOperatorProps>>(InitialStateIntegration);

  const [currentPage, setCurrentPage] = useState(0);
  const [isEditBuyOrder, setIsEditBuyOrder] = useState<boolean>(false);

  useEffect(() => {
    getDataIntegration();
  }, [currentPage, tableFilter, user?.selectedCustomerId, isEditBuyOrder]);

  const getDataIntegration = () => {
    setDataIntegration(InitialStateIntegration);

    healthOperatorServices.get(currentPage, pageTotal, tableDataIntegrationBy, tableFilter)
      .then((result: IBatchRequestResponse<HealthOperatorProps>) => {
        if (result) {
          const { error, data, totalPages, pageSize, total } = result;
          setDataIntegration({ error, data, totalPages, pageSize, total });
        }
      })
      .catch(error => {
        console.error("Erro na chamada da API:", error);
      });
  };

  return (
    <div>
      <ContainerFilterDataIntegration>
        <TableSearchDashDataIntegration
          placeholder="Ordem de compra, nota fiscal ou pedido"
          setTableFilter={setTableFilter}
          setCurrentPage={setCurrentPage}
        />
      </ContainerFilterDataIntegration>

      <TableDataIntegration
        trackingKey="Grid Integração de dados"
        model={modelDataIntegration()}
        dataIntegration={dataIntegration}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageTotal}
        DropdownTemplate={(data: any) => (
          <TableDataIntegrationItems
            key={data.id}
            model={modelDataIntegrationItems()}
            dataIntegration={data}
            setIsEditBuyOrder={setIsEditBuyOrder}
            isEditBuyOrder={isEditBuyOrder}
          />
        )}
      />
    </div>
  );
};
